import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41af50d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plants-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlantCard = _resolveComponent("PlantCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.plants.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["plants-grid__container", { 'plants-grid__container--masonry': _ctx.masonry }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plants, (plant) => {
            return (_openBlock(), _createBlock(_component_PlantCard, {
              key: plant.id,
              class: "plants-grid__item",
              plant: plant,
              style: _normalizeStyle({ gridRowEnd: _ctx.masonry ? `span ${plant.masonrySpan}` : null }),
              rect: !_ctx.masonry,
              "amplitude-key": _ctx.amplitudeKey
            }, null, 8, ["plant", "style", "rect", "amplitude-key"]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}